import getMessages from "../../../../messages";
var regex = /{(.*?)}/g;
var regexReplacer = function (values) { return function (_, c) { return values[c]; }; };
export var replacer = function (text, values) {
    if (text === void 0) { text = ""; }
    return text.replace(regex, regexReplacer(values));
};
export var getMessage = function (messageId, values) {
    var messages = values.businessUnitCode ? getMessages(values.businessUnitCode) : {};
    return values ? replacer(messages[messageId], values) : messages[messageId];
};
//# sourceMappingURL=getMessage.js.map